exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TodoSearch-default-1H1BL{margin-top:-30px}.TodoSearch-default-1H1BL h4,.TodoSearch-default-1H1BL h5{text-transform:uppercase}.TodoSearch-default-1H1BL h4{margin:30px 0;text-align:center}.TodoSearch-expectedDateStatus-Oezk3{text-align:center;color:#546d79}.TodoSearch-expectedDateStatus-Oezk3 small{margin-top:-30px;display:block;font-size:16px}.TodoSearch-expectedDateStatus-Oezk3 .ct-slice-donut,.TodoSearch-expectedDateStatus-Oezk3 button{opacity:.5}", ""]);

// exports
exports.locals = {
	"default": "TodoSearch-default-1H1BL",
	"expectedDateStatus": "TodoSearch-expectedDateStatus-Oezk3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/workflow/components/TodoSearch.less
// module id = 1787
// module chunks = 0